import { GridRowId, GridSelectionModel } from '@mui/x-data-grid-pro';
import { isDefined } from 'lib/typeguards';
import React from 'react';

export function useGridSingleSelection<T extends { id: string }>(
    items?: T[]
): [T, GridRowId[], (newSelectedRows: GridSelectionModel) => void] {
    const [selectionModel, setSelectionModel] = React.useState<GridRowId[]>([]);
    const handleSelectRow = React.useCallback((newSelectedRows: GridSelectionModel) => {
        // Enforces single selection
        if (newSelectedRows.length > 1) {
            setSelectionModel([newSelectedRows[newSelectedRows.length - 1]]);
        } else {
            setSelectionModel(newSelectedRows);
        }
    }, []);
    const selectedItem = React.useMemo(
        () => items?.find(item => isDefined(selectionModel?.[0]) && item.id === selectionModel?.[0]),
        [items, selectionModel]
    );
    return [selectedItem, selectionModel, handleSelectRow];
}
